var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7123 3.84C18.2889 3.83988 18.7639 4.24237 18.7913 4.7543L19.7686 22.9943C19.7827 23.2566 19.6753 23.5125 19.4714 23.7025C19.2676 23.8925 18.9851 24 18.6897 24H1.40968C1.1144 23.9999 0.832033 23.8923 0.628303 23.7023C0.424574 23.5123 0.317248 23.2565 0.331304 22.9943L1.30849 4.7543C1.33593 4.24241 1.81087 3.83993 2.38741 3.84H5.78217C5.78217 1.71923 7.7163 0 10.1022 0C12.488 0 14.4222 1.71923 14.4222 3.84H17.7123ZM13.3433 3.83703C13.3413 2.2472 11.8918 0.95883 10.1033 0.957031C8.31472 0.95883 6.8653 2.2472 6.86328 3.83703H13.3433ZM2.38766 4.80469H5.78242V8.16469C5.78242 8.42978 6.02419 8.64469 6.32242 8.64469C6.62065 8.64469 6.86242 8.42978 6.86242 8.16469V4.80469H13.3424V8.16469C13.3424 8.42978 13.5842 8.64469 13.8824 8.64469C14.1807 8.64469 14.4224 8.42978 14.4224 8.16469V4.80469H17.7001L18.4814 19.2047H1.61621L2.38766 4.80469ZM1.56254 20.1641L1.4082 23.0441H18.6882L18.5317 20.1641H1.56254Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.ef96f41d4f0266c8919c204c131b08d5.svg";
export { ForwardRef as ReactComponent };